import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';
import './CartIcon.css';

// Icon-based basket that slots into the main <ul> as a normal nav item.
// Swaps between empty/full images and shows a tiny count badge when > 0.
export default function CartIcon({
  emptySrc = '/images/basket-empty.png',
  fullSrc = '/images/basket-full.png',
  className = 'basket-link',
}) {
  const { getCartItemCount } = useCart();
  const itemCount = getCartItemCount ? getCartItemCount() : 0;
  const src = itemCount > 0 ? fullSrc : emptySrc;

  return (
    <Link
      to="/cart"
      className={className}
      aria-label={itemCount > 0 ? `Basket with ${itemCount} item${itemCount > 1 ? 's' : ''}` : 'Basket empty'}
    >
      <img src={src} alt="Basket" />
      {itemCount > 0 && <span className="basket-badge">{itemCount}</span>}
    </Link>
  );
}
